import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { Link } from 'react-router-dom';

const VendorDetailsModal = ({ vendorId, isOpen, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      if (!vendorId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await api.get('/admin/vendors/' + vendorId);
        if (response.data.success) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error('API Fetch Failed for Vendor Summary');
      } finally {
        setLoading(false);
      }
    };

    if (isOpen && vendorId) {
      fetchSummary();
    }
  }, [isOpen, vendorId]);

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-[100] flex items-center justify-center p-4'>
      <div 
        className='absolute inset-0 bg-stone-900/60 backdrop-blur-sm' 
        onClick={onClose} 
      />
      <div className='relative bg-white w-full max-w-2xl rounded-3xl overflow-hidden shadow-2xl border border-stone-200 animate-in fade-in zoom-in duration-300'>
        <div className='px-8 py-6 border-b border-stone-100 flex items-center justify-between bg-stone-50/50'>
          <div>
            <h3 className='text-xl font-bold text-[#201D42]'>Vendor Profile</h3>
            <p className='text-xs text-stone-500 font-medium'>Detailed shop and contact information</p>
          </div>
          <button 
            onClick={onClose} 
            className='w-10 h-10 rounded-full flex items-center justify-center hover:bg-stone-200 text-stone-500 transition-colors'
          >
            <span className='material-symbols-outlined'>close</span>
          </button>
        </div>
        
        <div className='p-8 overflow-y-auto max-h-[70vh]'>
          {loading ? (
            <div className='py-12 flex flex-col items-center justify-center'>
              <div className='w-10 h-10 border-4 border-t-transparent border-[#201D42] rounded-full animate-spin mb-4' />
              <p className='text-stone-500 font-black uppercase tracking-widest text-[10px]'>Retrieving Vendor Data...</p>
            </div>
          ) : data ? (
            <div className='space-y-8'>
              <div className='grid grid-cols-2 gap-4'>
                <div className='bg-stone-50 p-4 rounded-2xl border border-stone-100'>
                  <p className='text-[10px] font-black uppercase tracking-widest text-stone-400 mb-2'>Business Info</p>
                  <div className='space-y-3'>
                    <div className='flex items-center gap-3'>
                      <span className='material-symbols-outlined text-stone-400 text-lg'>store</span>
                      <p className='text-sm font-bold text-stone-800'>{data.shopName || 'No Shop Name'}</p>
                    </div>
                    <div className='flex items-center gap-3'>
                      <span className='material-symbols-outlined text-stone-400 text-lg'>badge</span>
                      <p className='text-xs font-bold text-stone-600'>{data.legalEntityName || 'No Legal Name'}</p>
                    </div>
                    <div className='flex items-center gap-3'>
                      <span className='material-symbols-outlined text-stone-400 text-lg'>person</span>
                      <p className='text-xs text-stone-500'>{data.contactPerson || 'No Contact Person'}</p>
                    </div>
                  </div>
                </div>
                
                <div className='bg-stone-50 p-4 rounded-2xl border border-stone-100'>
                  <p className='text-[10px] font-black uppercase tracking-widest text-stone-400 mb-2'>Contact Info</p>
                  <div className='space-y-3'>
                    <div className='flex items-center gap-3'>
                      <span className='material-symbols-outlined text-stone-400 text-lg'>call</span>
                      <p className='text-sm font-bold text-stone-800'>{data.phone || 'No Phone'}</p>
                    </div>
                    <div className='flex items-center gap-3'>
                      <span className='material-symbols-outlined text-stone-400 text-lg'>mail</span>
                      <p className='text-sm font-bold text-stone-800'>{data.email || 'No Email'}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className='flex items-center gap-3'>
                <div className={'px-4 py-2 rounded-full font-black uppercase tracking-widest text-[10px] bg-green-100 text-green-700'}>
                  {data.approved ? 'Approved Vendor' : 'Pending Approval'}
                </div>
                <div className='bg-stone-100 px-4 py-2 rounded-full font-black uppercase tracking-widest text-[10px] text-stone-600'>
                  GST: {data.gstin || 'N/A'}
                </div>
              </div>
              
              <div>
                <h4 className='text-sm font-black uppercase tracking-widest text-stone-400 mb-4 flex items-center gap-2'>
                  <span className='material-symbols-outlined text-lg'>location_on</span> Registered Address
                </h4>
                <div className='bg-stone-50 border border-stone-100 rounded-2xl p-4 shadow-sm'>
                  <p className='text-stone-800 text-sm'>{data.registeredAddress || 'No Address Provided'}</p>
                </div>
              </div>
              
              <div className='mt-6 pt-6 border-t border-stone-100 flex justify-end'>
                <Link to={`/vendors/${vendorId}`} onClick={onClose} className="bg-[#201D42] text-white px-5 py-2 rounded-xl font-bold text-xs hover:bg-[#14122B] transition-colors flex items-center gap-2">
                  View Full Vendor Dashboard <span className="material-symbols-outlined text-[14px]">arrow_forward</span>
                </Link>
              </div>
            </div>
          ) : (
            <div className='text-center py-12 text-stone-400'>No profile data available.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorDetailsModal;
